import axios from 'axios';
import formatParams from 'jquery-param';

export default {
  fetchTrainingEditorList({
    commit,
  }, params) {
    commit('setLoading', true);
    commit('setError', false);

    return axios.get(`/training?${formatParams(params)}`)
      .then((trainings) => {
        commit('setData', trainings);
      })
      .catch((err) => {
        commit('setError', err);
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },
};
